import React from "react";

export default function Vorwort() {
  return <></>;
}
